import { Account } from './getAccountFio'

interface IProfile extends Account {
  account_roles: IAccountRole[]
}

interface IAccountRole {
  role_type: IRoleType
}

interface IRoleType {
  tag: string
  name: string
}

export type Profile = IProfile
export type AccountRole = IAccountRole
export type RoleType = IRoleType

export const isProfileRoleTypeTags = (profile: Profile, tags: string[]): boolean => {
  let isRole = false

  if (!!profile && !!profile.account_roles) {
    profile.account_roles.forEach((role: AccountRole): void => {
      tags.forEach((tag: string): void => {
        if (role.role_type.tag === tag) {
          isRole = true
        }
      })
    })
  }

  return isRole
}
